module.exports = __webpack_public_path__ + "img/logo-diegoocania.ec3672c6.png";